var map = {
	"./help.svg": "c9325",
	"./huore.svg": "1a4b",
	"./moxing.svg": "ab24",
	"./renwu.svg": "9acc",
	"./shouye.svg": "d7fe",
	"./shujuku.svg": "68a1",
	"./suanfaku.svg": "7fc0",
	"./wode.svg": "3756",
	"./zhineng.svg": "0ec1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";